import { Component, ChangeDetectionStrategy, Input, OnInit } from '@angular/core';
import * as Models from '../../../models/models-index';

@Component({
  selector: 'stacked-two-kpi-metric',
  templateUrl: './stacked-two-kpi-metric.component.html',
  styleUrls: ['../panel-elements.scss', './stacked-two-kpi-metric.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class StackedTwoKpiMetricComponent implements Models.ElementComponent, OnInit {
  @Input() dataSet: Models.DataSet;
  @Input() settings: Models.ElementSettings;

  primaryMetricValue;
  primaryMetricTrend;
  primaryMetricLabel;
  secondaryMetricValue;
  secondaryMetricTrend;
  secondaryMetricLabel;

  constructor() { }

  ngOnInit() {

    const primaryColumn = this.dataSet.columns.find(c => c.name === this.settings.metricName)
      ?? this.throwError(`Invalid Config - '${this.settings.metricName}' is not available in dataset '${this.dataSet.name}'`);
    const primaryMetricIndex = this.dataSet.columns.findIndex(col => col.name === this.settings.metricName);
    const primaryMetricTrendIndex = this.dataSet.columns.findIndex(col => col.name === this.settings.metricTrend);

    const secondaryColumn = this.dataSet.columns.find(c => c.name === this.settings.secondaryMetricName)
      ?? this.throwError(`Invalid Config - '${this.settings.secondaryMetricName}' is not available in dataset '${this.dataSet.name}'`);
    const secondaryMetricIndex = this.dataSet.columns.findIndex(col => col.name === this.settings.secondaryMetricName);
    const secondaryMetricTrendIndex = this.dataSet.columns.findIndex(col => col.name === this.settings.secondaryMetricTrend);

    const primaryRowValue = this.dataSet.rows[0][primaryMetricIndex]
    const primaryTrendRowValue =  this.dataSet.rows[0][primaryMetricTrendIndex];

    this.primaryMetricValue = primaryRowValue.label ?? primaryRowValue.value;
    this.primaryMetricTrend = primaryTrendRowValue.value;
    this.primaryMetricLabel = primaryColumn.displayName ?? primaryColumn.name;

    const secondaryRowValue = this.dataSet.rows[0][secondaryMetricIndex];
    const secondaryTrendRowValue = this.dataSet.rows[0][secondaryMetricTrendIndex];

    this.secondaryMetricValue = secondaryRowValue.label ?? secondaryRowValue.value;
    this.secondaryMetricTrend = secondaryTrendRowValue.value;
    this.secondaryMetricLabel = secondaryColumn.displayName ?? secondaryColumn.name;
  }

  getTrendArrowIconClass(trend: number): string {
    const isTrendUp = this.isTrendUp(trend);

    if (isTrendUp === null || trend === 0) {
      return 'fa fa-horizontal-rule';
    } else if (trend > 0) {
      return 'fa fa-chevron-circle-up chevron-icon';
    } else if (trend < 0) {
      return 'fa fa-chevron-circle-down chevron-icon';
    }
  }

  getTrendIconColor(trend: number): string {
    const isTrendUp = this.isTrendUp(trend);

    if (isTrendUp === null) {
      return 'bg-yellow';
    } else if (!isTrendUp) {
      return 'bg-red';
    } else if (!!isTrendUp) {
      return 'bg-green';
    }
  }

  getTrendColor(trend: number): string {
    const isTrendUp = this.isTrendUp(trend);
    if (isTrendUp == null) {
      return 'text-yellow';
    } else if (!!isTrendUp) {
      return 'text-green';
    } else if (!isTrendUp) {
      return 'text-red';
    }
  }

  isTrendUp(value: number) {
    if (!value || value === 0)
      return null;

    return value > 0
      ? this.settings.metricInverted ? false : true
      : this.settings.metricInverted ? true : false;
  }

  throwError(errorMessage: string): never {
    throw new Error(errorMessage);
  }

}
